import ToastDialog from "components/Common/ToastDialog";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap";
import * as Yup from "yup";

//Import Breadcrumb
import {
  addProprietor,
  callGetCity,
  callGetState,
  editAddress,
  editAuthorisedPersonStatus,
  getAuthorisedPersonList,
  getPersonAddress,
} from "http/fundLync/entityAndAddress.helper";
import { dateFormat, decryptedValue, isPermission } from "common/utility";

const currentDate = new Date().toISOString().split("T")[0];

const Proprietors = (props) => {
  // document.title = "proprietors | FundLync";
  const [proprietorList, setProprietorList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [stateList, setState] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedOption, setSelectedOption] = useState("No");
  const [address, setAddress] = useState([])
  const [isAddProprietorPermission, setAddProprietorPermission] = useState(false);
  const [isEditProprietorPermission, setEditProprietorPermission] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);

  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  const ProprietorList = () => {
    getAuthorisedPersonList({ entityId, type: "proprietor" })
      .then((response) => {
        const allProprietors = response.data?.data || [];
        if (allProprietors.length > 0) {
          setProprietorList(allProprietors);
          setSelectedOption(allProprietors[0]?.selfEmployed)
          getPersonAddress({ personId: allProprietors[0]?.id })
            .then((response) => {
              if (response.code == 200 && response.status) {
                setAddress(response.data)
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }

  useEffect(() => {
    ProprietorList()
    callGetState()
      .then((response) => {
        if (response.code == "200") {
          setState(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    checkPermissions()
  }, [entityId]);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };
  const checkPermissions = async () => {
    const addProprietorpermission = await isPermission(
      "authorised_person",
      "create_permission"
    );
    const editProprietorpermission = await isPermission(
      "authorised_person",
      "edit_permission"
    );

    setAddProprietorPermission(addProprietorpermission);
    setEditProprietorPermission(editProprietorpermission);
  };

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: proprietorList[0]?.firstName || "",
      lastName: proprietorList[0]?.lastName || "",
      gender: proprietorList[0]?.gender || "",
      fatherName: proprietorList[0]?.fatherName || "",
      dob: proprietorList[0]?.dob ||null,
      selfEmployed: proprietorList[0]?.selfEmployed || "No",
      address1: address[0]?.address1 || "",
      address2: address[0]?.address2 || "",
      address3: address[0]?.address3 || "",
      city: address[0]?.city || "",
      state: address[0]?.state || "",
      pincode: address[0]?.pincode || "",
      id: address[0]?.id || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().nullable(),
      lastName: Yup.string().nullable(),
      fatherName: Yup.string().nullable(),
      dob: Yup.date().nullable().optional(),
      gender: Yup.string().nullable().nullable(),
      selfEmployed: Yup.string().nullable(),
      address1: Yup.string().nullable(),
      address2: Yup.string().nullable(),
      address3: Yup.string().nullable(),
      city: Yup.string().nullable(),
      state: Yup.string().nullable(),
      pincode: Yup.string().nullable(),
      id: Yup.string().nullable(),
    }),
    onSubmit: (values) => {
      let proprietorObj = {
        firstName: values.firstName,
        lastName: values.lastName,
        gender: values.gender,
        fatherName: values.fatherName,
        dob: values.dob,
        selfEmployed: selectedOption,
        address1: values.address1,
        address2: values.address2 || null,
        address3: values.address3 || null,
        city: values.city,
        state: values.state,
        pincode: values.pincode,
        entityId: +entityId,
        type: "proprietor"
      }
      if (proprietorList.length == 0) {
        addProprietor(proprietorObj)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Propreitor Details Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        let updateProprietorObj = {
          firstName: values.firstName,
          lastName: values.lastName,
          gender: values.gender,
          fatherName: values.fatherName,
          dob: values.dob,
          selfEmployed: selectedOption,
          entityId: +entityId,
          type: "proprietor",
          id: proprietorList[0]?.id
        }

        let updateAddressObj = {
          id: address[0]?.id,
          entityId: +entityId,
          address1: values.address1,
          address2: values.address2 || null,
          address3: values.address3 || null,
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          personId: proprietorList[0]?.id
        }

        editAuthorisedPersonStatus(updateProprietorObj)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Propreitor Details Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave()
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error)
          })
         editAddress(updateAddressObj)
      }
    },
  });

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  function setStateValue(data, state) {
    if (state) {
      for (const item of data) {
        if (item.name === state) {
          const value = { label: `${item.name}`, value: state };
          return value;
        }
      }
    }
  }

  function setCityValue(data, city) {
    if (city) {
      const cityOption = data.find((item) => item.cityName === city);
      if (cityOption) {
        return { label: cityOption.cityName, value: cityOption.cityName };
      }
    }
    return null;
  }
  useEffect(() => {
    if (validation.values.state) {
      getCityList(validation.values.state);
    }
  }, [validation.values.state]);

  
  const handleInputChange = (value) => {
    validation.setFieldValue('state', value);
    validation.setFieldValue("city", "")
    getCityList(value)
  };

  const handleCityChange = (value) => {
    validation.setFieldValue("city", value);
  };

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data)
          const selectedCity = address[0]?.city || validation.values.city;
          validation.setFieldValue("city", selectedCity); 
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
  //meta title

  const handleChange = (field, value) => {
    validation.setFieldValue(field, value);
  };

  function setGender(data, gender) {
    if (gender) {
      for (const item of data) {
        if (item.value === gender) {
          const value = { label: `${item.label}`, value: gender };
          return value;
        }
      }
    }
  }
  const callAfterSave = () => {
    getAuthorisedPersonList({ entityId, type: "proprietor" })
      .then((response) => {
        setEditMode(false)
        const allProprietors = response.data?.data || [];
        if (allProprietors.length > 0) {
          setProprietorList(allProprietors);
          setSelectedOption(allProprietors[0]?.selfEmployed)
          getPersonAddress({ personId: allProprietors[0]?.id })
            .then((response) => {
              if (response.code == 200 && response.status) {
                setAddress(response.data)
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          {isAddProprietorPermission && <Card className="p-3">
            <CardBody>
            {proprietorList.length > 0 ? (
          <div className="text-end mb-3">
            <div onClick={toggleEditMode} style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                  >
                    close
                  </Button>
                </div>
                : <i className="mdi mdi-pencil font-size-16 text-success me-1"><span className="font-size-12">Edit</span></i>}
            </div>
          </div>
        ) : (
          <div className="text-end mb-3">
            <div onClick={toggleEditMode} style={{ cursor: "pointer" }}>
              {editMode ?
                <div className="text-sm-end">
                  <Button 
                    type="button"
                    color="outline-success"
                    className="btn-rounded mb-2 me-2"
                  >
                    close
                  </Button>
                </div>
                : <div className="d-flex justify-content-end">
                  <Button
                    type="button"
                    style={{ backgroundColor: '#21aa47', borderColor: '#21aa47', color: '#fff' }}
                    className="mb-3 me-2"
                  >
                    <i className="fas fa-plus me-2"></i>
                    <span >
                      {" "}
                      Add Proprietor
                    </span>
                  </Button>
                </div>}
              </div>
            </div>
        )}
              { editMode ? (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row className="mb-4">
                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Proprietor First Name</Label>
                    <Input
                      name="firstName"
                      type="text"
                      placeholder="Insert Proprietor First Name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.firstName || ""}
                      invalid={
                        validation.touched.firstName && validation.errors.firstName
                          ? true
                          : false
                      }
                    />
                    {validation.touched.firstName && validation.errors.firstName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.firstName}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Proprietor Last Name</Label>
                    <Input
                      name="lastName"
                      type="text"
                      placeholder="Insert Proprietor Last Name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.lastName || ""}
                      invalid={
                        validation.touched.lastName && validation.errors.lastName
                          ? true
                          : false
                      }
                    />
                    {validation.touched.lastName && validation.errors.lastName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.lastName}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Father's Name</Label>
                    <Input
                      name="fatherName"
                      type="text"
                      placeholder="Enter Father's Name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.fatherName || ""}
                      invalid={
                        validation.touched.fatherName &&
                          validation.errors.fatherName
                          ? true
                          : false
                      }
                    />
                    {validation.touched.fatherName &&
                      validation.errors.fatherName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.fatherName}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Date Of Birth</Label>
                    <Input
                      name="dob"
                      type="date"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.dob || ""}
                      max={currentDate}
                      invalid={
                        validation.touched.dob && validation.errors.dob
                          ? true
                          : false
                      }
                    />
                    {validation.touched.dob && validation.errors.dob ? (
                      <FormFeedback type="invalid">
                        {validation.errors.dob}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6" className="mb-3">
                    <Label className="form-label mt-4">Select Gender</Label>
                    <Select
                      options={genderOptions}
                      placeholder={'Select Gender'}
                      className={`select-dropdown ${validation.touched.gender &&
                        validation.errors.gender
                        ? "is-invalid"
                        : ""
                        }`}
                      name='gender'
                      id='gender'
                      onChange={(selectedOption) => {
                        handleChange("gender", selectedOption.value);
                      }}
                      value={setGender(
                        genderOptions,
                        validation.values.gender
                      )}
                    />
                    {validation.touched.gender &&
                      validation.errors.gender && (
                        <FormFeedback>
                          {validation.errors.gender}
                        </FormFeedback>
                      )}
                  </Col>

                  <Col sm="12" lg="6">
                    <Label className="form-label mt-4">
                      Are you a self-employed professional?
                    </Label>
                    <div className="d-flex">
                      <div className="form-check ">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios1"
                          value="Yes"
                          checked={selectedOption == "Yes"}
                          onClick={handleOptionChange}
                          onChange={validation.handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleRadios1"
                        >
                          Yes
                        </label>
                      </div>
                      <div
                        className="form-check"
                        style={{ marginLeft: "10px" }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          id="exampleRadios2"
                          value="No"
                          checked={selectedOption == "No"}
                          onClick={handleOptionChange}
                          onChange={validation.handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleRadios2"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="font-size-16">
                      <b>Current residential address</b>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Address Line1</Label>
                    <Input
                      name="address1"
                      type="text"
                      placeholder="Insert Address Line1"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.address1 || ""}
                      invalid={
                        validation.touched.address1 &&
                          validation.errors.address1
                          ? true
                          : false
                      }
                    />
                    {validation.touched.address1 &&
                      validation.errors.address1 ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address1}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Address Line2</Label>
                    <Input
                      name="address2"
                      type="text"
                      placeholder="Insert Address Line2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.address2 || ""}
                      invalid={
                        validation.touched.address2 &&
                          validation.errors.address2
                          ? true
                          : false
                      }
                    />
                    {validation.touched.address2 &&
                      validation.errors.address2 ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address2}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Address Line3</Label>
                    <Input
                      name="address3"
                      type="text"
                      placeholder="Insert Address Line3"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.address3 || ""}
                      invalid={
                        validation.touched.address3 &&
                          validation.errors.address3
                          ? true
                          : false
                      }
                    />
                    {validation.touched.address3 &&
                      validation.errors.address3 ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address3}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">State</Label>
                    <Select
                      options={stateList.map((option, index) => ({
                        label: option.name,
                        value: option.name,
                      }))}
                      className={`${validation.touched.state && validation.errors.state
                        ? "is-invalid"
                        : ""
                        }`}
                      name="state"
                      id="state"
                      onChange={(selectedOption) => {
                        handleInputChange(selectedOption.value);
                      }}
                      value={setStateValue(stateList, validation.values.state)}
                    />
                    {validation.touched.state && validation.errors.state && (
                      <FormFeedback>{validation.errors.state}</FormFeedback>
                    )}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">City</Label>
                    <Select
                      options={cityList.map((option) => ({
                        label: option.cityName,
                        value: option.cityName,
                      }))}
                      className={`select-dropdown ${validation.touched.city && validation.errors.city
                        ? "is-invalid"
                        : ""
                        }`}
                      name="city"
                      id="city"
                      onChange={(selectedOption) => {
                        handleCityChange(selectedOption.value);
                      }}
                      value={setCityValue(
                        cityList,
                        validation.values.city
                      )}
                    />
                    {validation.touched.city && validation.errors.city ? (
                      <FormFeedback type="invalid">
                        {validation.errors.city}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4">Pincode</Label>
                    <Input
                      name="pincode"
                      type="text"
                      placeholder="Insert pincode"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.pincode || ""}
                      invalid={
                        validation.touched.pincode && validation.errors.pincode
                          ? true
                          : false
                      }
                    />
                    {validation.touched.pincode && validation.errors.pincode ? (
                      <FormFeedback type="invalid">
                        {validation.errors.pincode}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>

                <Row>
                  <Col className="mt-4">
                    {isEditProprietorPermission && <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-customer"
                      >
                        Save
                      </button>
                    </div>}
                  </Col>
                </Row>
              </Form>
              ) : (
                <div> 
                    {proprietorList.length > 0 ? (
                      proprietorList?.map((proprietor, index) => (
                        <React.Fragment key={index}>
                          {/* <p >{index + 1}. Partner Details</p> */}
                          <Row className="mt-5">
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">First Name</Label>
                              <span className="mb-0 entityDetailsValue">{proprietor.firstName || '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Last Name</Label>
                              <span className="mb-0 entityDetailsValue">{proprietor.lastName || '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Father's Name</Label>
                              <span className="mb-0 entityDetailsValue">{proprietor.fatherName || '-'}</span>
                            </Col>
                          </Row>
                          <Row className="mt-5">
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Date of Birth</Label>
                              <span className="mb-0 entityDetailsValue">{dateFormat(proprietor.dob, "DD/MM/YYYY")|| '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Gender</Label>
                              <span className="mb-0 entityDetailsValue">{proprietor.gender || '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Are you a self-employed professional?</Label>
                              <span className="mb-0 entityDetailsValue">{proprietor.selfEmployed || '-'}</span>
                            </Col>
                          </Row>
                          
                          
                          <Row className="mt-5">
                            <Col>
                              <div className="font-size-14">
                                <b>Current residential address</b>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-5">
                            <Col sm="12" className="mb-3">
                              <Label className="d-block entityDetails">Address</Label>
                              <span className="mb-0 entityDetailsValue">
                                {`${validation.values.address1 || ''} ${validation.values.address2 || ''} ${validation.values.address3 || ''}`}
                              </span>
                            </Col>
                            </Row>
                            <Row className="mt-5">
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">State</Label>
                              <span className="mb-0 entityDetailsValue">{validation.values.state || '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">City</Label>
                              <span className="mb-0 entityDetailsValue">{validation.values.city || '-'}</span>
                            </Col>
                            <Col sm="4" className="mb-3">
                              <Label className="d-block entityDetails">Pincode</Label>
                              <span className="mb-0 entityDetailsValue">{validation.values.pincode || '-'}</span>
                            </Col>
                            <div style={{ marginTop: '3%', borderTop: '1px solid #d7d7d7' }}></div>
                          </Row>
                        </React.Fragment>
                      ))
                      ) : (
                    <div className="mt-5">
                      <p className="text-center">No Proprietor records available.</p>
                    </div>
                  )}
                </div>
                )}
            </CardBody>
          </Card>}
        </Col>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default Proprietors;
